export default "__VITE_ASSET__85357a6c__"